import { render } from "./EvmCoin.vue?vue&type=template&id=ce411c94"
import script from "./EvmCoin.vue?vue&type=script&lang=js"
export * from "./EvmCoin.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__